const AudioComponentSelector = "audio-component";
const VideoComponentSelector = "video-component";

export { AudioComponentSelector, VideoComponentSelector };
//# sourceMappingURL=index.selectors.js.map
